{
  "version": 1,
  "asset_id": "26481e1f-522c-4789-85e8-2d971578db43",
  "project_id": "449b2c5b-fdd9-48b8-8f0a-7dd2027bc221",
  "url": "/__l5e/assets-v1/26481e1f-522c-4789-85e8-2d971578db43/jcpsinsider.webp",
  "r2_key": "a/v1/449b2c5b-fdd9-48b8-8f0a-7dd2027bc221/26481e1f-522c-4789-85e8-2d971578db43/jcpsinsider.webp",
  "original_filename": "jcpsinsider.webp",
  "size": 156250,
  "content_type": "image/webp",
  "created_at": "2026-08-13T21:33:06Z"
}
